/**
 * APH external WordPress checkout.
 * Builds: https://checkout.aphscience.com/?add-to-cart=SKU:QTY,SKU:QTY
 * SKU falls back to variant_id when Shopify SKU is blank (current catalogue).
 */
(function () {
  'use strict';

  function checkoutBase() {
    var base =
      (window.APH && window.APH.externalCheckoutUrl) ||
      (window.theme && window.theme.externalCheckoutUrl) ||
      'https://checkout.aphscience.com';
    return String(base).replace(/\/$/, '');
  }

  function enabled() {
    if (window.APH && typeof window.APH.externalCheckoutEnabled === 'boolean') {
      return window.APH.externalCheckoutEnabled;
    }
    return true;
  }

  function buildPairsFromCart(cart) {
    var pairs = [];
    (cart.items || []).forEach(function (item) {
      var key = item.sku || item.variant_id || item.id;
      if (!key) return;
      pairs.push(String(key) + ':' + String(item.quantity || 1));
    });
    return pairs;
  }

  function paidPenceFromCart(cart) {
    var paid = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._aph_gift || props._free_protein) return;
      paid += Number(item.final_line_price || item.line_price || 0);
    });
    return paid;
  }

  function saleMode() {
    var mode = '';
    try {
      mode = document.documentElement.getAttribute('data-aph-sale') || '';
    } catch (err) {}
    if (mode === 'PAYDAY30' || mode === 'PAYDAY40' || mode === 'PAYDAY3040') return mode;
    if (typeof aphSaleMode === 'function') {
      var m = aphSaleMode();
      if (m === 'PAYDAY30' || m === 'PAYDAY40' || m === 'PAYDAY3040') return m;
    }
    try {
      var cfgEl = document.getElementById('aph-header-cart-config');
      var j = cfgEl ? JSON.parse(cfgEl.textContent) : null;
      if (j && j.discount) return j.discount;
    } catch (err2) {}
    return mode;
  }

  function paydayCode(cart) {
    var code = typeof aphSaleDiscountCode === 'function' ? aphSaleDiscountCode() : '';
    if (code && code !== 'PAYDAY3040') return code;
    var mode = saleMode();
    var paid = 0;
    if (typeof aphSalePaidPence === 'function') paid = aphSalePaidPence() || 0;
    if (!paid) paid = paidPenceFromCart(cart);
    if (mode === 'PAYDAY3040') {
      if (paid >= 8000) return 'PAYDAY40';
      if (paid >= 5000) return 'PAYDAY30';
      return '';
    }
    if (mode === 'PAYDAY30') return paid >= 5000 ? 'PAYDAY30' : '';
    if (mode === 'PAYDAY40') return paid >= 8000 ? 'PAYDAY40' : '';
    return '';
  }

  function buildUrlFromPairs(pairs, cart) {
    var base = checkoutBase();
    if (!pairs.length) return base + '/';
    var url = base + '/?add-to-cart=' + pairs.join(',');
    /* Sale: Woo needs PAYDAY30|40. Never send PAYDAY3040. Also pass coupon= same code. */
    var code = paydayCode(cart);
    if (code && code !== 'PAYDAY3040') {
      url += '&discount=' + encodeURIComponent(code);
      url += '&coupon=' + encodeURIComponent(code);
      url += '&coupon_code=' + encodeURIComponent(code);
    }
    return url;
  }

  window.APH = window.APH || {};
  window.APH.buildExternalCheckoutUrl = function (cart) {
    return buildUrlFromPairs(buildPairsFromCart(cart || {}), cart || {});
  };

  window.APH.goToExternalCheckout = function (cart) {
    var url = window.APH.buildExternalCheckoutUrl(cart);
    window.location.href = url;
    return url;
  };

  function fetchCart() {
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function handleCheckoutClick(e) {
    if (!enabled()) return;
    var btn = e.target.closest(
      '[data-aph-external-checkout], .aph-external-checkout, #CartDrawer-Checkout, #checkout, button[name="checkout"], a[href*="/checkout"]'
    );
    if (!btn) return;
    // allow real external links that already point at checkout.aphscience
    if (btn.tagName === 'A' && btn.getAttribute('href') && btn.getAttribute('href').indexOf('checkout.aphscience.com') !== -1) {
      e.preventDefault();
      e.stopPropagation();
    }
    // only intercept Shopify cart checkout CTAs
    var isCheckoutCta =
      btn.hasAttribute('data-aph-external-checkout') ||
      btn.classList.contains('aph-external-checkout') ||
      btn.id === 'CartDrawer-Checkout' ||
      btn.id === 'checkout' ||
      btn.getAttribute('name') === 'checkout' ||
      (btn.tagName === 'A' && /\/checkout(\?|$)/.test(btn.getAttribute('href') || ''));
    if (!isCheckoutCta) return;

    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.aphCheckoutBusy === '1') return;
    btn.dataset.aphCheckoutBusy = '1';
    var prev = btn.getAttribute('aria-busy');
    btn.setAttribute('aria-busy', 'true');

    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          btn.dataset.aphCheckoutBusy = '0';
          btn.setAttribute('aria-busy', prev || 'false');
          return;
        }
        var pairs = buildPairsFromCart(cart);
        if (!pairs.length) {
          // no sku/variant - fall back to Shopify cart page
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        window.location.href = buildUrlFromPairs(pairs, cart);
      })
      .catch(function () {
        btn.dataset.aphCheckoutBusy = '0';
        btn.setAttribute('aria-busy', prev || 'false');
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
  }

  document.addEventListener('click', handleCheckoutClick, true);

  // Also intercept cart form submit (checkout)
  document.addEventListener(
    'submit',
    function (e) {
      if (!enabled()) return;
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      var isCartForm =
        form.id === 'CartDrawer-Form' ||
        form.id === 'cart' ||
        action.indexOf('/cart') !== -1 ||
        form.querySelector('[name="checkout"]');
      if (!isCartForm) return;
      // only when checkout is the submitter
      var submitter = e.submitter || document.activeElement;
      if (submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout') {
        e.preventDefault();
        handleCheckoutClick({
          target: submitter,
          preventDefault: function () {},
          stopPropagation: function () {},
        });
      }
    },
    true
  );
})();
